var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2176",
    d: "M9.10719 17.8307H8.22484C4.89728 17.8307 3.2335 17.8307 2.19976 16.8544C1.16602 15.8781 1.16602 14.3068 1.16602 11.1641L1.16602 7.83073C1.16602 4.68803 1.16602 3.11668 2.19976 2.14037C3.2335 1.16406 4.89728 1.16406 8.22484 1.16406L9.10719 1.16406C12.4348 1.16406 14.0985 1.16406 15.1323 2.14037C16.166 3.11668 16.166 4.68803 16.166 7.83073V8.2474",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4435",
    d: "M5.33203 5.32812H11.9987",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4436",
    d: "M5.33203 9.5H9.4987",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4993 16.7567V17.8281M14.4993 16.7567C13.5354 16.7567 12.6861 16.2832 12.1879 15.5642M14.4993 16.7567C15.4633 16.7567 16.3126 16.2832 16.8108 15.5642M14.4993 11.3996C15.4634 11.3996 16.3128 11.8731 16.8109 12.5922M14.4993 11.3996C13.5353 11.3996 12.6859 11.8731 12.1878 12.5922M14.4993 11.3996V10.3281M17.8327 11.9353L16.8109 12.5922M11.1664 16.221L12.1879 15.5642M11.166 11.9353L12.1878 12.5922M17.8323 16.221L16.8108 15.5642M16.8109 12.5922C17.1054 13.0174 17.2771 13.5284 17.2771 14.0781C17.2771 14.6279 17.1054 15.139 16.8108 15.5642M12.1878 12.5922C11.8933 13.0174 11.7216 13.5284 11.7216 14.0781C11.7216 14.6279 11.8933 15.139 12.1879 15.5642",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRule);
export default __webpack_public_path__ + "static/media/rule.e13b55af1a8fa3041af3d2494f4a06cc.svg";
export { ForwardRef as ReactComponent };